import request from '@/utils/request'

function checked(promise) {
  return promise.then(response => {
    if (!response || String(response.code) !== '0') throw new Error((response && (response.message || response.msg)) || '意向金操作失败，请重试')
    return response
  })
}

const base = '/intent'
export default {
  configs(params) { return checked(request.get(base + '/configs', { params })) },
  config(id) { return checked(request.get(base + '/configs/' + id)) },
  createConfig(data) { return checked(request.post(base + '/configs', data)) },
  updateConfig(id, data) { return checked(request.put(base + '/configs/' + id, data)) },
  configState(id, data) { return checked(request.post(base + '/configs/' + id + '/state', data)) },
  configLogs(id) { return checked(request.get(base + '/configs/' + id + '/logs')) },
  orders(params) { return checked(request.get(base + '/orders', { params })) },
  order(id) { return checked(request.get(base + '/orders/' + id)) },
  orderLogs(id) { return checked(request.get(base + '/orders/' + id + '/logs')) },
  meetingOptions(id) { return checked(request.get(base + '/orders/' + id + '/meeting-options')) },
  meetingDeduct(id, data) { return checked(request.post(base + '/orders/' + id + '/meeting-deduct', data)) },
  joinOptions(id) { return checked(request.get(base + '/orders/' + id + '/join-options')) },
  joinDeduct(id, data) { return checked(request.post(base + '/orders/' + id + '/join-deduct', data)) },
  income(id, data) { return checked(request.post(base + '/orders/' + id + '/income', data)) },
  usageMark(id, data) { return checked(request.post(base + '/orders/' + id + '/usage-mark', data)) },
  addNote(id, data) { return checked(request.post(base + '/orders/' + id + '/notes', data)) },
  registrationCredit(id) { return checked(request.get(base + '/registrations/' + id + '/credit')) },
  // BUG-2026-418721：本客户同账号名下可抵扣的意向金
  joinCoupons(params) { return checked(request.get(base + '/join/coupons', { params })) },
  resolveCode(data) { return checked(request.post(base + '/join/code-resolve', data)) },
  returnApplication(id, data) { return checked(request.post(base + '/applications/' + id + '/return', data)) },
  exportOrder(id) { return request.get(base + '/orders/' + id + '/export', { responseType: 'blob' }) },
  exportOrders(params) { const { pageNo, pageSize, ...filters } = params || {}; return request.get(base + '/orders/export', { params: filters, responseType: 'blob' }) }
}
